import { IFormConfig } from '../../interfaces/FormConfig';

export class FormStepHelpers {
    static addFormStep(
        field: any,
        index: number,
        data: any,
        formStep: string,
        formDefinitions: any,
        formConfig: IFormConfig
    ) {
        let addFormStep: boolean = true;

        if (index + 1 < data.form.field.length) {
            let nextField: any = data.form.field[index + 1];
            if (
                nextField.settings.controlname == 'PopupOK' ||
                nextField.settings.controlname == 'PopupConfirm'
            ) {
                addFormStep = false;
            }
        }

        const addFormStepCaption = !formConfig.formStepCaptions || formConfig.formStepCaptions.length == 0;

        if (addFormStep) {
            formStep = field['@column'];
            const formStepCaption = field.properties && field.properties.fieldcaption ? field.properties.fieldcaption : field['@column'];
            
            formDefinitions[formStep] = [];
            
            //if (addFormStepCaption) 
            {
                formConfig.formStepCaptions.push(formStepCaption);
            }

            formConfig.formSteps.push(formStep);
            formConfig.pageSettings[formStep] = {
                title: field.properties.fieldcaption,
                subtitle: field.settings.Subtitle || ""
            };
        }

        return formStep;
    }
}
